import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { colors, GridWrapper } from "../../theme";
import VerticalShareBar from "../VerticalShareBar";
import JoinUs from "../JoinUsAside";

const Container = styled(GridWrapper)`
  > h1 {
    color: black;
    font-size: 4.2rem;
    font-weight: 100;
    letter-spacing: -0.04rem;
    line-height: 4.6rem;
    margin-bottom: 58px;
    text-transform: uppercase;

    @media (max-width: 1023px) {
      margin-bottom: 40px;
    }
  }
`;

const Content = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;

  @media (max-width: 1023px) {
    margin-bottom: 30px;
  }

  > div {
    font-size: 1.7rem;
    line-height: 2.4rem;
    width: 730px;

    @media (max-width: 1599px) {
      width: 500px;
    }

    @media (max-width: 1023px) {
      width: calc(100% - 76px);
    }

    @media (max-width: 767px) {
      width: 100%;
    }
  }

  h2 {
    color: black;
    font-size: 4.2rem;
    font-weight: 100;
    letter-spacing: -0.04rem;
    line-height: 4.6rem;
    margin: 33px 0 24px;
    text-transform: uppercase;
  }

  h3 {
    color: black;
    text-transform: uppercase;
  }

  p {
    margin-bottom: 2.4rem;
  }

  a {
    color: ${colors.primaryColor};
    transition: 0.3s;

    :hover {
      color: ${colors.primaryHover};
    }
  }

  strong {
    color: black;
    font-weight: 600;
  }

  ul,
  ol {
    margin: 30px 0;
  }

  li {
    margin-bottom: 15px;
  }

  aside {
    width: 283px;

    @media (max-width: 1023px) {
      display: none;
    }
  }
`;

const Share = styled(VerticalShareBar)`
  margin-left: 16px;
  position: sticky;
  top: 120px;

  @media (max-width: 1599px) {
    margin-left: 8px;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

const Headline = styled.div`
  color: black;
  font-size: 2.2rem;
  font-weight: 500;
  line-height: 2.8rem;

  p {
    margin-bottom: 2.8rem;
  }
`;

function AnnexesLayout({ title, headline, children }) {
  return (
    <Container>
      <h1>{title}</h1>
      <Content>
        <Share text={title} />
        <div>
          {headline && <Headline>{headline}</Headline>}
          {children}
        </div>
        <aside>
          <JoinUs />
        </aside>
      </Content>
    </Container>
  );
}

AnnexesLayout.propTypes = {
  title: PropTypes.string.isRequired,
  headline: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default AnnexesLayout;
